export default "__VITE_ASSET__bf46c9a3__"